import { BudgetBys } from 'business/constants';
import { translateBlock, translateComponent } from 'i18n';
import { getResourceType } from 'routes/BudgetModule/helpers/budgetProposalHelpers';
export const getResourceLabel = (
    by: BudgetBys,
    isSchool: boolean,
    bind: string,
) => {
    if (bind === 'ampmetropole') {
        return translateBlock('gestionnaire.name');
    }
    return isSchool
        ? translateComponent('budgetProposal.schoolResource')
        : translateComponent(`budget.${getResourceType(by)}`);
};
